/* unplugin-vue-components disabled */import { render } from "./UserCert.vue?vue&type=template&id=4ffbf1bc&scoped=true"
import script from "./UserCert.vue?vue&type=script&lang=js"
export * from "./UserCert.vue?vue&type=script&lang=js"

import "./UserCert.vue?vue&type=style&index=0&id=4ffbf1bc&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/plp-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ffbf1bc"]])

export default __exports__